import { ApiVisa } from 'blg-akaun-ts-lib';
import { environment } from '../../environments/environment';

export class AppConfig {
  static readonly apiVisa: ApiVisa = {
    tenantCode: sessionStorage.getItem('tenantCode'),
    api_domain_url: environment.api_domain,
    jwt_secret: localStorage.getItem('authToken')
  };
  static readonly masterVisa: ApiVisa = {
    tenantCode: 'akaun_master',
    api_domain_url: environment.api_domain,
    jwt_secret: localStorage.getItem('authToken')
  };
  static readonly peppolVisa: ApiVisa = {
    tenantCode: 'peppolap',
    api_domain_url: environment.api_domain,
    jwt_secret: localStorage.getItem('authToken')
  };
  static setAppletToken() {
    this.apiVisa.jwt_secret = sessionStorage.getItem('appletToken');
    this.masterVisa.jwt_secret = sessionStorage.getItem('appletToken');
    this.peppolVisa.jwt_secret = sessionStorage.getItem('appletToken');
  }
}
